import React, {useReducer, type ComponentProps} from 'react';
import {EyeIcon, EyeSlashIcon} from '@heroicons/react/24/outline';
import InputText from './Input.Text';

interface IInputSecretProps extends ComponentProps<typeof InputText> {}

const InputSecret = (props: IInputSecretProps) => {
  const [hide, toggleHide] = useReducer(s => !s, true);
  const eyeClassName = 'size-5 text-slate-500 dark:text-white';
  return (
    <InputText
      {...props}
      type={hide ? props.type : 'text'}
      suffix={
        <button type="button" onClick={toggleHide} className="text-slate-500 dark:text-darkText active:scale-90 duration-200 cursor-pointer">
          {hide ? <EyeSlashIcon className={eyeClassName} /> : <EyeIcon className={eyeClassName} />}
        </button>
      }
    />
  );
};

export default React.memo(InputSecret);
